import { EmptyPageState, NavigationGlyph } from '@traceio-org/ui';
import { ActionLink } from '../../components/AdminProblem';
import { useOrganizationScope } from './scope';

/** An address under an organization that names no section of it. */
export function SectionNotFound() {
  const { tabPath } = useOrganizationScope();
  return (
    <EmptyPageState
      icon={<NavigationGlyph name="FileWarning" />}
      title="This section does not exist"
      description="The address names no section of this organization."
      action={<ActionLink to={tabPath('')}>Go to the overview</ActionLink>}
    />
  );
}
